import { h } from "preact";

import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
	root: {
		flexGrow: 1,
	},
	menuButton: {
		marginRight: theme.spacing(2),
	},
	title: {
		flexGrow: 1,
	},
}));

export default function Picto1() {
	const classes = useStyles();

	return (
		<svg width="475px" height="849px" viewBox="0 0 475 849" version="1.1" xmlns="http://www.w3.org/2000/svg">
			<title>k</title>
			<g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" opacity="0.05">
				<g id="k" transform="translate(0.006142, 0.000000)" fill="#F81937" fill-rule="nonzero">
					<g id="Group">
						<polyline
							id="Path"
							points="233.953858 344.07 233.953858 611.72 233.953858 650.31 233.953858 734.24 233.953858 847.7 119.553858 847.7 119.553858 344.07"
						></polyline>
						<path
							d="M176.763858,114.4 C211.209857,114.4 239.133858,142.324 239.133858,176.77 C239.133858,211.216 211.209857,239.14 176.763858,239.14 C142.317858,239.14 114.393858,211.216 114.393858,176.77 C114.432435,142.339992 142.333849,114.438577 176.763858,114.4 M233.993858,344.07 C315.770952,316.074811 365.317616,233.055774 351.135315,147.790974 C336.953013,62.5261741 263.200097,0.0158557118 176.763858,1.96287431e-14 L176.763858,1.96287431e-14 C90.3313962,0.0256255986 16.5876049,62.538957 2.41074558,147.800834 C-11.7661137,233.062711 37.7803332,316.076041 119.553858,344.07"
							id="Shape"
						></path>
						<path
							d="M232.913858,611.71 L327.243858,506.91 C331.997191,501.576667 337.680524,498.91 344.293858,498.91 L428.743858,498.91 C438.823858,498.91 443.867191,502.853333 443.873858,510.74 C443.933773,512.461745 443.591373,514.173741 442.873858,515.74 C441.738247,517.712381 440.397476,519.559294 438.873858,521.25 L325.853858,640.61 L468.083858,823.28 L467.533858,823.28 C469.693601,825.347606 471.423411,827.821676 472.623858,830.56 C473.555647,832.688754 474.068334,834.977172 474.133858,837.3 C474.133858,841.533333 472.987191,844.426667 470.693858,845.98 C468.400524,847.533333 464.963858,848.31 460.383858,848.31 L367.383858,848.31 C364.10999,848.249122 360.974815,846.977239 358.583858,844.74 C355.144007,841.533594 352.09914,837.928095 349.513858,834 L259.513858,706.62 L232.873858,734.23"
							id="Path"
						></path>
					</g>
				</g>
			</g>
		</svg>
	);
}
